import { E_ITEM_TYPE } from "../types/print-product-model.types";
import type {
  ITextItem,
  IContainer,
  ILayoutItem,
  IPlaceholderItem,
  TItem,
} from "../types/print-product-model.types";

type TMapItemsType = {
  [E_ITEM_TYPE.BOUNDED_TEXT]: ITextItem;
  [E_ITEM_TYPE.PLAIN_TEXT]: ITextItem;
  [E_ITEM_TYPE.PLACEHOLDER]: IPlaceholderItem;
  [E_ITEM_TYPE.LAYOUT]: ILayoutItem;
};

export function findVariableItems<T extends E_ITEM_TYPE.BOUNDED_TEXT | E_ITEM_TYPE.PLACEHOLDER>(
  container: IContainer,
  findType: T
): Array<TMapItemsType[T]>;

export function findVariableItems(
  container: IContainer,
  findType?: undefined
): Array<ITextItem | IPlaceholderItem>;

export function findVariableItems<T extends E_ITEM_TYPE>(
  container: IContainer,
  findType?: T
): Array<TMapItemsType[T] | ITextItem | IPlaceholderItem> {
  function flatItems(items: TItem[]): (ITextItem | IPlaceholderItem | ILayoutItem)[] {
    return items.flatMap((item) => {
      if (item.$type === 'LayoutItem') {
        return flatItems(item.items);
      }
      return [item];
    });
  }

  const items = flatItems(container.items);

  const filtered = items.filter((item): item is ITextItem | IPlaceholderItem | ILayoutItem =>
    item.isVariable && (findType === undefined || item.$type === findType)
  );

  if (findType === undefined) {
    return filtered.filter(
      (item): item is ITextItem | IPlaceholderItem =>
        item.$type === E_ITEM_TYPE.BOUNDED_TEXT || item.$type === E_ITEM_TYPE.PLACEHOLDER
    );
  }

  return filtered as Array<TMapItemsType[T]>;
}